import classNames from 'classnames';
import styles from './list.module.scss';
import { ListItemsNavigator } from 'src/components/common/items-navigator';

/**
 * @typedef {{
 *   onItemSelected: (id: string, index: number) => void,
 *   selected: string,
 *   labelTextProperty: string,
 *   dataSource: Array<any>,
 *   icon?: React.ComponentType,
 *   showIcon?: (item: any) => boolean,
 *   props: import('../../common/items-navigator/list/list-items-navigator').ListItemsNavigatorProps
 * }} ListProps
 */

/**
 * List component
 * @param {ListProps} params
 * @param params.onItemSelected - The function to call when an item is selected
 * @param params.selected - The id of the selected item
 * @param params.labelTextProperty - The property of the item to use as the label
 * @param params.dataSource - The array of items to render
 * @param params.icon - The icon to display on the right of each item
 * @param params.showIcon - A function to determine if the icon should be shown
 * @param params.props - The rest of the props
 */
export function List({
  onItemSelected,
  selected,
  labelTextProperty,
  dataSource = [],
  icon: Icon = () => {},
  showIcon = () => false,
  className,
  ...props
}) {
  const renderItem = (item, index) => {
    const isSelected = item.id === selected;
    return (
      <button
        key={item.id}
        className={classNames(styles.item, { [styles.itemSelected]: isSelected })}
        onClick={() => onItemSelected(item.id, index)}>
        <p
          className={classNames(styles.itemTitle, {
            [styles.itemSelectedText]: isSelected,
          })}>
          {item[labelTextProperty]}
          {showIcon(item) && <Icon />}
        </p>
      </button>
    );
  };

  return (
    <ListItemsNavigator {...props} className={classNames(styles.list, className)}>
      {dataSource.map((item, index) => renderItem(item, index))}
    </ListItemsNavigator>
  );
}
